/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIResponseBase,
  GetOauth2UiConfiguration200Response,
  OAuthClientUIConfiguration,
  PutOauth2UiConfiguration201Response,
} from '../models';
import {
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
    GetOauth2UiConfiguration200ResponseFromJSON,
    GetOauth2UiConfiguration200ResponseToJSON,
    OAuthClientUIConfigurationFromJSON,
    OAuthClientUIConfigurationToJSON,
    PutOauth2UiConfiguration201ResponseFromJSON,
    PutOauth2UiConfiguration201ResponseToJSON,
} from '../models';

export interface GetOauth2UiConfigurationRequest {
    slashIDOrgID: string;
    oauthClientId: string;
}

export interface PutOauth2UiConfigurationRequest {
    slashIDOrgID: string;
    oauthClientId: string;
    slashIDRequiredConsistency?: PutOauth2UiConfigurationSlashIDRequiredConsistencyEnum;
    slashIDRequiredConsistencyTimeout?: number;
    body?: OAuthClientUIConfiguration;
}

/**
 * 
 */
export class OAuth2Api extends runtime.BaseAPI {

    /**
     * The configuration is used to theme the hosted UI. 
     * Retrieve the configuration for the hosted UI
     */
    async getOauth2UiConfigurationRaw(requestParameters: GetOauth2UiConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOauth2UiConfiguration200Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling getOauth2UiConfiguration.');
        }

        if (requestParameters.oauthClientId === null || requestParameters.oauthClientId === undefined) {
            throw new runtime.RequiredError('oauthClientId','Required parameter requestParameters.oauthClientId was null or undefined when calling getOauth2UiConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/oauth2/clients/{oauth_client_id}/ui-configuration`.replace(`{${"oauth_client_id"}}`, encodeURIComponent(String(requestParameters.oauthClientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOauth2UiConfiguration200ResponseFromJSON(jsonValue));
    }

    /**
     * The configuration is used to theme the hosted UI. 
     * Retrieve the configuration for the hosted UI
     */
    async getOauth2UiConfiguration(requestParameters: GetOauth2UiConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOauth2UiConfiguration200Response> {
        const response = await this.getOauth2UiConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The configuration is used to theme the hosted UI. 
     * Modify the configuration for the hosted UI
     */
    async putOauth2UiConfigurationRaw(requestParameters: PutOauth2UiConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PutOauth2UiConfiguration201Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling putOauth2UiConfiguration.');
        }

        if (requestParameters.oauthClientId === null || requestParameters.oauthClientId === undefined) {
            throw new runtime.RequiredError('oauthClientId','Required parameter requestParameters.oauthClientId was null or undefined when calling putOauth2UiConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (requestParameters.slashIDRequiredConsistency !== undefined && requestParameters.slashIDRequiredConsistency !== null) {
            headerParameters['SlashID-Required-Consistency'] = String(requestParameters.slashIDRequiredConsistency);
        }

        if (requestParameters.slashIDRequiredConsistencyTimeout !== undefined && requestParameters.slashIDRequiredConsistencyTimeout !== null) {
            headerParameters['SlashID-Required-Consistency-Timeout'] = String(requestParameters.slashIDRequiredConsistencyTimeout);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/oauth2/clients/{oauth_client_id}/ui-configuration`.replace(`{${"oauth_client_id"}}`, encodeURIComponent(String(requestParameters.oauthClientId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PutOauth2UiConfiguration201ResponseFromJSON(jsonValue));
    }

    /**
     * The configuration is used to theme the hosted UI. 
     * Modify the configuration for the hosted UI
     */
    async putOauth2UiConfiguration(requestParameters: PutOauth2UiConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PutOauth2UiConfiguration201Response> {
        const response = await this.putOauth2UiConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const PutOauth2UiConfigurationSlashIDRequiredConsistencyEnum = {
    LocalRegion: 'local_region',
    AllRegions: 'all_regions'
} as const;
export type PutOauth2UiConfigurationSlashIDRequiredConsistencyEnum = typeof PutOauth2UiConfigurationSlashIDRequiredConsistencyEnum[keyof typeof PutOauth2UiConfigurationSlashIDRequiredConsistencyEnum];
